/** LocalStorage key: nominated admin has completed the nav tour. */
export const nominatedAdminNavTourStorageKey = (companyCode: string) =>
  `rv_nominee_nav_tour_seen_${String(companyCode || "").trim()}`;

export type NomineeNavTourStep = {
  id: string;
  title: string;
  body: string;
  /** Run before highlighting (e.g. open Administration panel). */
  onEnter?: () => void;
};
